import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as _ from 'underscore';

// Service
import { ProductivityListService } from '../../service/productivity-list/productivity-list.service';

@Component({
	selector: 'app-productivity-list',
	templateUrl: './productivity-list.component.html',
	providers: [
		ProductivityListService,
		HttpModule
	]
})
export class ProductivityListComponent implements OnInit {

	private token;
	prodForm: FormGroup;
	public productivity: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;

	constructor(fb: FormBuilder, private productivityListService: ProductivityListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.prodForm = fb.group({
			'Nome': '',
			'Status': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchProductivity(this.prodForm.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchProductivity(this.prodForm.value, this.currentPage, false);
	}
	searchProductivity(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.productivityListService.searchProductivity(this.token, value.Nome, value.Status, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.productivity = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchProductivity(this.prodForm.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/productivity/component/productivity-list/productivity-list.component.ts